import { render, staticRenderFns } from "./Commoditydetails.vue?vue&type=template&id=69148b2a&scoped=true&"
import script from "./Commoditydetails.vue?vue&type=script&lang=js&"
export * from "./Commoditydetails.vue?vue&type=script&lang=js&"
import style0 from "./Commoditydetails.vue?vue&type=style&index=0&id=69148b2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69148b2a",
  null
  
)

export default component.exports